import { getRouter } from '@app/utils/routing/Context'
import { waitFor } from '@app/utils/waitFor'

import { configSelector } from '@app/store/slices/config'
import { profileUserSelector } from '@app/store/slices/profile'
import { isSupervisedSelector } from '@app/store/slices/session'
import { createThunk } from '@app/store/thunk'

import { getMount } from '@app/components/Mount/actions'

export function requireTOSAccept() {
  return createThunk<Promise<boolean>>(async (dispatch, getState) => {
    const mount = dispatch(getMount())
    const router = dispatch(getRouter())
    const user = profileUserSelector(getState())
    const { isApp } = configSelector(getState())
    if (
      !user ||
      user.tos_accepted ||
      isApp ||
      isSupervisedSelector(getState()) ||
      router.location.pathname === '/licence' ||
      router.location.pathname === '/licence-parent' ||
      router.location.pathname === '/licence-sitter'
    )
      return true

    const mountCtx = await waitFor(() => mount)

    return new Promise<boolean>(resolve => {
      const close = mountCtx.push(
        import('@app/components/TOSAccept/TOSModal').then(m => m.TOSModal),
        {
          autoclose: false,
          zIndex: 100,
          props: {
            onSuccess: async () => {
              await close()
              resolve(true)
            },
          },
        }
      )
    })
  })
}
